import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { VistoriaEndereco } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria-endereco.entity';
import { Vistoria } from '@tivic-team/manager-ts/dist/mob/entities/vistoria/vistoria.entity';
import { ConcessaoDTO } from './concessao.dto';

export class VistoriaDTO extends Vistoria {
    veiculo: Veiculo = void(0);
	concessaoDTO: ConcessaoDTO = void(0);
	pessoa: Pessoa = void(0);
	nrPlaca: string = void(0);
    nrPrefixo: string = void(0);
    cdVistoria: number = void(0);
    cdEndereco: number = void(0);
    nmLogradouro: string = void(0);
	nmBairro: string = void(0);
	nrEndereco: string = void(0);
    vistoriaEndereco: VistoriaEndereco = void(0);
    cdPessoaOrgao: number = void(0);
    cdConcessaoVeiculo: number = void(0);

    constructor(
        veiculo?: Veiculo,
	    concessaoDTO?: ConcessaoDTO,
	    pessoa?: Pessoa,
	    nrPlaca?: string,
        nrPrefixo?: string,
        cdVistoria?: number,
        cdEndereco?: number,
        nmLogradouro?: string,
        nmBairro?: string,
        nrEndereco?: string,
        vistoriaEndereco?: VistoriaEndereco,
        cdPessoaOrgao?: number,
        cdConcessaoVeiculo?: number,
    ){
        super();
        veiculo = veiculo;
	    concessaoDTO = concessaoDTO;
	    pessoa = pessoa;
	    nrPlaca = nrPlaca;
        nrPrefixo = nrPrefixo;
        cdVistoria = cdVistoria;
        cdEndereco = cdEndereco;
        nmLogradouro = nmLogradouro;
        nmBairro = nmBairro;
        nrEndereco = nrEndereco;
        vistoriaEndereco = vistoriaEndereco;
        cdPessoaOrgao = cdPessoaOrgao;
        cdConcessaoVeiculo = cdConcessaoVeiculo;
    }
}
export class VistoriaListDTO {
    items: Array<VistoriaDTO>;
    total: number;
    constructor(){}
}